module.exports = __webpack_public_path__ + "static/media/financeboi.6dae208d.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/financeboi.PNG
// module id = 92
// module chunks = 0